import React, { useEffect, useState } from "react";
import image from "../../Asset/addaddress/image.png";
import { FaMapMarkerAlt } from "react-icons/fa";
import addressModel from "../../model/address.model";
import { useLocation, useNavigate } from "react-router-dom";
import back from "../../Asset/product/back.png";
import { toast } from "../../lib/helper";

const DropDownAddress = () => {
  const [selectmark, setSelectMark] = useState();

  const Navigate = useNavigate();

  const AddsAddress = async (e) => {
    e.preventDefault();

    const form = new FormData(e.target);
    form.append("address_type", selectmark);
    form.append("latitude", "0");
    form.append("longitude", "0");

    addressModel
      .AddAddress(form)
      .then((responce) => {
        toast(responce?.data?.message, "success");
        console.log("fffff - type", responce);
      //  Navigate("/");
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  const location = useLocation();


    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location?.pathname]);
  return (
    <div className="w-full pt-4 pl-4 pr-5 pb-28   bg-Background3  pl:5  md:pl-20 md:pr-20 md:pt-20 md:pb-44" style={{ backgroundImage: `url(${back})` }}>
      <form
        className="grid grid-cols-1 lg:grid-cols-2 gap-6 justify-center"
        onSubmit={AddsAddress}
      >
        <div className="w-full flex justify-center ">
          <div className="w-3/4  mt-24">
            <img src={image} alt="img" className="w-full object-cover" />
          </div>
        </div>
        <div className="w-full  flex flex-col p-2">
          <div>
            <span className="text-3xl title1 font-bold text-textColor">
              Add New Address
            </span>
          </div>
          {/* 
      <div className='mt-10'>
        <span className='text-xl font-semibold text-textColor'>Accurate Location</span>
      </div>
      <div className='mt-3 w-full bg-Background1 rounded-lg'>
        <div className='px-8 py-5 '>
          <div className='flex justify-between text-textColor'>
              <div className='flex gap-4 items-center '><FaMapMarkerAlt />  <span>Select Map Location</span></div>
              <div><button className='bg-textColor text-white px-8 py-0.5 rounded-2xl cursor-pointer'>Select</button></div>
          </div>
        </div>
      </div>
      */}
          <div
            className="mt-4 text-lg font-semibold text-textColor"
            style={{ backgroundImage: `url(${back})` }}
          >
            <span className="title1 text-[15px]">Enter Address Details</span>
          </div>
          <div className="mt-3 w-full  bg-white rounded-lg">
            <div className="px-8 py-2 ">
              <input
                type="text"
                name="house_number"
                placeholder="Flat/House Number/Building Name*"
                required
                className="w-full p-1 outline-none"
              />
            </div>
          </div>
          <div className="mt-5 w-full bg-white rounded-lg">
            <div className="px-8 py-2 ">
              <input
                type="text"
                name="society_name"
                placeholder="Society Name*"
                className="w-full p-1 outline-none"
                required
              />
            </div>
          </div>
          <div className="mt-5 w-full bg-white rounded-lg">
            <div className="px-8 py-2 ">
              <input
                type="text"
                name="how_to_reach"
                placeholder="How to reach (optional)"
                className="w-full p-1 outline-none"
              />
             
            </div>
          </div>
          {/* 
      <div className='mt-4 text-lg font-semibold text-textColor'><span>Personal Details</span></div>
      <div className='mt-3 w-full  bg-white rounded-lg'>
        
        <div className='px-8 py-5 '>
         <input type='text' placeholder='Name' className='w-full p-1 outline-none'/>
        </div>
      </div>
      <div className='mt-3 w-full bg-white rounded-lg'>
        
        <div className='px-8 py-5 '>
         <input type='text' placeholder='Mobile number*' className='w-full p-1 outline-none'/>
        </div>
      </div>
*/}

          <div className="mt-4 text-base font-semibold text-textColor">
            <span className="title1 text-[15px]">Address Type</span>
          </div>
          <div className="mt-3 w-full  rounded-lg">
            <div className="px-8 py-7 flex gap-8 ">
              <div
                className={`bg-Background2 text-base font-bold text-textColor py-3 px-8 cursor-pointer rounded-lg transform transition duration-300 hover:scale-105 ${
                  selectmark == "home" ? "border-2 border-textColor" : ""
                }`}
                onClick={() => {
                  setSelectMark("home");
                }}
              >
                <span className="title2 text-[13px]">Home</span>
              </div>
              <div
                className={`bg-Background2 text-base font-bold text-textColor py-3 px-8 cursor-pointer rounded-lg transform transition duration-300 hover:scale-105${
                  selectmark == "office" ? "border-2 border-textColor" : ""
                }`}
                onClick={() => {
                  setSelectMark("office");
                }}
              >
                <span className="title2 text-[13px]">Office</span>
              </div>
              <div
                className={`bg-Background2 text-base font-bold text-textColor py-3 px-8 cursor-pointer rounded-lg transform transition duration-300 hover:scale-105${
                  selectmark == "other" ? "border-2 border-textColor" : ""
                }`}
                onClick={() => {
                  setSelectMark("other");
                }}
              >
                <span className="title2 text-[13px]">Other</span>
              </div>
            </div>
          </div>
          <div className="mt-16 text-base font-semibold text-textColor w-full px-3  ">
            <button
              type="submit"
              className="w-full text-white bg-textColor hover:text-gray-300 py-2.5 text-xl rounded-3xl"
            >
              Submit & Save
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default DropDownAddress;
